// extracted by mini-css-extract-plugin
module.exports = {"ContainerBack":"InstructionOverlay_ContainerBack__35EiK","ContainerFront":"InstructionOverlay_ContainerFront__20CO2"};